import React, { Component } from "react";
import ViewMoreSection from "ReactComponents/Shared/AnimationComponents/view-more-section";

class SystemDetails extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="system-details-container">
                <div className="system-details__img">
                    <div className="system-details__img__inner">
                        {this.props.SystemDetails.ImageUrls &&
                            this.props.SystemDetails.ImageUrls.map((image, index) => {
                                return (
                                    <img
                                        loading="lazy"
                                        key={index}
                                        src={image}
                                        alt={`Udvalgte forsider i ${this.props.SystemDetails.Title}-serien`}
                                    />
                                );
                            })}
                    </div>
                </div>
                <div className="system-details__meta">
                    <h1
                        className="system-details__meta__title"
                        dangerouslySetInnerHTML={{ __html: this.props.SystemDetails.Title }}
                    />
                    <p
                        className="system-details__meta__subtitle"
                        dangerouslySetInnerHTML={{ __html: this.props.SystemDetails.SubTitle }}
                    />
                    <ViewMoreSection>
                        <div
                            className="content-rich-text"
                            dangerouslySetInnerHTML={{ __html: this.props.SystemDetails.Description }}
                        />
                    </ViewMoreSection>
                </div>
                {(this.props.SystemDetails.MaterialsCount > 0 ||
                    this.props.SystemDetails.SubSystemsCount > 0 ||
                    this.props.SystemDetails.GradesText) && (
                    <div className="system-details__facts-container">
                        <h3
                            className="system-details__facts__title"
                            dangerouslySetInnerHTML={{ __html: this.props.RightSectionTitle }}
                        />
                        <ul className="system-details__facts__list">
                            {this.props.SystemDetails.MaterialsCount > 0 && (
                                <li className="system-details__facts__item">
                                    <span className="system-details__facts__icon material" />
                                    <span
                                        className="system-details__facts__key"
                                        dangerouslySetInnerHTML={{ __html: this.props.MaterialsLablelText }}
                                    />
                                    <span
                                        className="system-details__facts__value"
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.SystemDetails.MaterialsCount
                                        }}
                                    />
                                </li>
                            )}
                            {this.props.SystemDetails.SubSystemsCount > 0 && (
                                <li className="system-details__facts__item">
                                    <span className="system-details__facts__icon subsystems" />
                                    <span
                                        className="system-details__facts__key"
                                        dangerouslySetInnerHTML={{ __html: this.props.SubSystemsLabelText }}
                                    />
                                    <span
                                        className="system-details__facts__value"
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.SystemDetails.SubSystemsCount
                                        }}
                                    />
                                </li>
                            )}
                            {this.props.SystemDetails.GradesText && (
                                <li className="system-details__facts__item">
                                    <span className="system-details__facts__icon levels" />
                                    <span
                                        className="system-details__facts__key"
                                        dangerouslySetInnerHTML={{ __html: this.props.GradeLabelText }}
                                    />
                                    <span
                                        className="system-details__facts__value"
                                        dangerouslySetInnerHTML={{
                                            __html: this.props.SystemDetails.GradesText
                                        }}
                                    />
                                </li>
                            )}
                        </ul>
                    </div>
                )}
            </div>
        );
    }
}
export default SystemDetails;
